import React, {useEffect, useState} from "react";
import {
    Button,
    Col,
    Row,
} from "react-bootstrap";
import {useParams, useHistory} from "react-router-dom";
import {useSelector, useDispatch} from "react-redux";
import {
    sortCaret,
    headerSortingClasses,
} from "../../../_metronic/_helpers";
import {
    Card,
    CardBody,
    CardHeader,
    CardHeaderToolbar
} from "../../../_metronic/_partials/controls";
import {LayoutSplashScreen} from "../../../_metronic/layout";
import {
    formLabelsTheme,
    iconError,
    showDialog,
    showErrorDialog
} from "../../utility";
import SVG from "react-inlinesvg";
import {
    toAbsoluteUrl,
} from "../../../_metronic/_helpers";
import {
    selectPagination,
} from "../../modules/Auth/_redux/authRedux";

// MUI
import {
    ThemeProvider,
    TextField
} from "@material-ui/core";

import {
    resetData,
    selectLoading,
    selectLogPageNo,
    selectLogPageSize,
    selectLogTotalRecord,
    selectSavedVehicleList,
    selectTransactionLogList,
    selectReporting2,
    fetchReportingVehicleInfo,
    fetchTransactionLogs,
    saveVehicleList
} from "./transactionLogSlice";
import {VehicleInformationTable} from "./VehicleInformationTable";
import {VehicleTransactionLogTable} from "./VehicleTransactionLogTable";

import {useStyles, useStylesReddit} from "../../utility";

import {Autocomplete} from "@material-ui/lab";

function RedditTextField(props) {
    const classes = useStylesReddit();

    return (
        <TextField InputProps={{classes, disableUnderline: true}} {...props} />
    );
}

const columns = [
    {
        text: "VIN",
        dataField: "vin",
        sort: true,
        sortCaret: sortCaret,
        headerSortingClasses,
        style: {minWidth: "160px"},
    },
    {
        text: "VON",
        dataField: "von",
        sort: true,
        sortCaret: sortCaret,
        headerSortingClasses,
        style: {minWidth: "160px"},
    },
    {
        text: "Inbound Job",
        dataField: "inbound_job",
        sort: true,
        sortCaret: sortCaret,
        headerSortingClasses,
        style: {minWidth: "160px"},
    },
    {
        text: "Vehicle Name",
        dataField: "vehicle_name",
        sort: true,
        sortCaret: sortCaret,
        headerSortingClasses,
        style: {minWidth: "160px"},
    },
    {
        text: "Vehicle Status",
        dataField: "vehicle_status",
        sort: true,
        sortCaret: sortCaret,
        headerSortingClasses,
        style: {minWidth: "160px"},
    },
    {
        text: "Inbound",
        dataField: "inbound_dom",
        sort: true,
        sortCaret: sortCaret,
        headerSortingClasses,
        style: {minWidth: "160px"},
    },
    {
        text: "Outbound",
        dataField: "outbound_dom",
        sort: true,
        sortCaret: sortCaret,
        headerSortingClasses,
        style: {minWidth: "160px"},
    },
    {
        text: "Factory Name",
        dataField: "factory_name",
        sort: true,
        sortCaret: sortCaret,
        headerSortingClasses,
        style: {minWidth: "160px"},
    },
    {
        text: "Client",
        dataField: "client",
        sort: true,
        sortCaret: sortCaret,
        headerSortingClasses,
        style: {minWidth: "160px"},
    }
]

export const VehicleTransactionLogPage = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const history = useHistory();
    const data = useSelector(selectTransactionLogList);
    const vehicleDetail = useSelector(selectReporting2);
    const vehicleList = useSelector(selectSavedVehicleList);
    const loading = useSelector(selectLoading);
    const pageNo = useSelector(selectLogPageNo);
    const pageSize = useSelector(selectLogPageSize);
    const totalRecord = useSelector(selectLogTotalRecord);
    const paginationSet = useSelector(selectPagination);

    const {id} = useParams();

    useEffect(() => {
        async function fetchMyAPI() {
            // Fetch data on first load
            await dispatch(
                fetchReportingVehicleInfo({
                    vehicle_id: id
                })
            );

            let params = {
                pageNo: 1,
                pageSize: paginationSet,
            };
            await dispatch(
                fetchTransactionLogs({vehicle_id: id, payload: params})
            );
        }

        fetchMyAPI();
    }, [dispatch]);

    const optionsVin = vehicleList ? vehicleList.map((e) => ({
        value: e.vehicle_id,
        label: e.vin ? e.vin : e.von,
    })) : [];

    const [formValues, setFormValues] = useState({
        vinVon: {
            value: id ?? "",
            error: false,
            required: "N",
        },
    });

    const handleRefresh = async () => {
        let params = {
            pageNo: 1,
            pageSize: paginationSet,
        };

        try {
            await dispatch(
                fetchReportingVehicleInfo({
                    vehicle_id: formValues.vinVon.value
                })
            );

            const response = await dispatch(fetchTransactionLogs({
                vehicle_id: formValues.vinVon.value,
                payload: params
            }));
            if (response.payload.data.status === 200) {
            } else {
                showErrorDialog(response.payload.data.message);
            }
        } catch (error) {
            showErrorDialog(error.message);
        }
    };

    const handleTableChange = async (
        type,
        {page, sizePerPage, sortField, sortOrder, data}
    ) => {
        if (type === "pagination") {
            let params = {
                pageNo: page,
                pageSize: sizePerPage,
            };

            try {
                const response = await dispatch(fetchTransactionLogs({
                    vehicle_id: formValues.vinVon.value,
                    payload: params
                }));
                if (response.payload.data.status === 200) {
                } else {
                    showErrorDialog(response.payload.data.message);
                }
            } catch (error) {
                showErrorDialog(error.message);
            }
        } else {
            let result;
            if (sortOrder === "asc") {
                result = data.sort((a, b) => {
                    if (a[sortField] > b[sortField]) {
                        return 1;
                    } else if (b[sortField] > a[sortField]) {
                        return -1;
                    }
                    return 0;
                });
            } else {
                result = data.sort((a, b) => {
                    if (a[sortField] > b[sortField]) {
                        return -1;
                    } else if (b[sortField] > a[sortField]) {
                        return 1;
                    }
                    return 0;
                });
            }
        }
    };

    const handleChange = (newValue) => {
        if (newValue === null || newValue.length === 0) {
            setFormValues({
                ...formValues,
                ["vinVon"]: {
                    ...formValues["vinVon"],
                    value: "",
                },
            });
        } else {
            setFormValues({
                ...formValues,
                ["vinVon"]: {
                    ...formValues["vinVon"],
                    value: newValue.value,
                },
            });
        }

        dispatch(resetData());
        dispatch(saveVehicleList(vehicleList));
        history.push(`/motor-pool/vehicle-information/${newValue.value}`, 'Vehicle Transaction Log');
    }

    return loading ? (
        <LayoutSplashScreen/>
    ) : (
        <>
            <div>
                <Card>

                    <CardHeader title="Vehicle Transaction Log">
                        <CardHeaderToolbar>
                        </CardHeaderToolbar>
                    </CardHeader>
                    <CardBody>
                        <>
                            <div className="mb-5">
                                <ThemeProvider theme={formLabelsTheme}>
                                    <Row>
                                        <Col xs={12} sm={3} md={6} lg={6}>
                                            <Row>
                                                <Col xs={10} sm={3} md={9} lg={9}>
                                                    <Autocomplete
                                                        disableCloseOnSelect
                                                        options={optionsVin}
                                                        getOptionLabel={(option) => `${option.label}`}
                                                        getOptionValue={(option) => option.value}
                                                        value={
                                                            optionsVin.find(
                                                                (option) =>
                                                                    (!formValues.vinVon.value && option.value === id) ||
                                                                    (formValues.vinVon.value && option.value === formValues.vinVon.value)
                                                            ) || null
                                                        }
                                                        onChange={(event, newValue) => {
                                                            handleChange(newValue)
                                                        }}
                                                        renderInput={(params) => (
                                                            <RedditTextField
                                                                className={classes.margin}
                                                                {...params}
                                                                label="VIN/VON"
                                                                id="reddit-input"
                                                                size="small"
                                                                fullWidth
                                                                placeholder="Select"
                                                                name="vinVon"
                                                            />
                                                        )}
                                                    />
                                                </Col>
                                                <Col xs={1} sm={1} md={1} lg={1}>
                                                    <div>
                                                        <a className="display-flex btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mt-5">
                              <span
                                  className="svg-icon svg-icon-md svg-icon-light"
                                  onClick={() => {
                                      handleRefresh();
                                  }}
                              >
                                <SVG
                                    src={toAbsoluteUrl(
                                        "/media/svg/icons/New/Arrow/rotate-right.svg"
                                    )}
                                />
                              </span>
                                                        </a>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </ThemeProvider>
                            </div>
                        </>

                        <VehicleInformationTable
                            tableColumns={columns}
                            data={vehicleDetail || []}
                            loading={loading}
                            withPagination={false}
                            clickableRow={false}
                        />
                        <VehicleTransactionLogTable
                            data={data || []}
                            page={pageNo}
                            sizePerPage={pageSize}
                            totalSize={totalRecord}
                            onTableChange={handleTableChange}
                            loading={loading}
                            handleSearch={handleRefresh}
                        />
                    </CardBody>
                </Card>
            </div>
        </>
    );
};
